// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.external-host-container {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
}

.external-host-container > .external-host-header {
  flex: 0 0 auto;
  margin-top: 0;
}

.external-host-shell {
  padding: 0;
  border-radius: 16px;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.external-host-shell--framed {
  position: relative;
  min-height: 0;
  flex: 1 1 auto;
  padding: 12px;
  border-radius: 22px;
  border: 1px solid #e2e8f0;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7),
    0 16px 40px rgba(15, 23, 42, 0.1);
  box-sizing: border-box;
  overflow: hidden;
}

.external-host-frame {
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.external-host-shell--framed .external-host-frame {
  height: 100%;
  min-height: 0;
  border-radius: 16px;
  background: #ffffff;
}

.external-host-loading {
  position: absolute;
  inset: 12px;
  display: grid;
  place-items: center;
  margin: 0;
  color: #64748b;
  font-weight: 700;
  pointer-events: none;
}

.external-host-header .crumb {
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ExternalHost.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC;qCACmC;EACnC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".external-host-container {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.external-host-container > .external-host-header {\n  flex: 0 0 auto;\n  margin-top: 0;\n}\n\n.external-host-shell {\n  padding: 0;\n  border-radius: 16px;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.external-host-shell--framed {\n  position: relative;\n  min-height: 0;\n  flex: 1 1 auto;\n  padding: 12px;\n  border-radius: 22px;\n  border: 1px solid #e2e8f0;\n  background: rgba(255, 255, 255, 0.92);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7),\n    0 16px 40px rgba(15, 23, 42, 0.1);\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.external-host-frame {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n}\n\n.external-host-shell--framed .external-host-frame {\n  height: 100%;\n  min-height: 0;\n  border-radius: 16px;\n  background: #ffffff;\n}\n\n.external-host-loading {\n  position: absolute;\n  inset: 12px;\n  display: grid;\n  place-items: center;\n  margin: 0;\n  color: #64748b;\n  font-weight: 700;\n  pointer-events: none;\n}\n\n.external-host-header .crumb {\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
